const comments = [
  {
    name: '吃瓜群众小明',
    text: '自从发现51吃瓜爆料网，每天上班摸鱼都有新乐子！台北娜娜那期真的笑死我了，轻量版播放超流畅。',
    time: '2小时前',
    avatar: 'M',
  },
  {
    name: '娱乐先锋阿杰',
    text: '玩偶姐姐合集做得太全了，不用到处找了。吃瓜娱乐现场更新速度真的快，每次刷新都有新内容。',
    time: '5小时前',
    avatar: 'J',
  },
  {
    name: '吃瓜不停小美',
    text: '莫里秀那个搞笑吃瓜瞬间我能循环看十遍！网红直播翻车合集是我的快乐源泉，推荐给所有朋友了。',
    time: '8小时前',
    avatar: 'X',
  },
  {
    name: '八卦达人老王',
    text: '吃瓜真人秀片段剪辑得特别到位，高能部分一个没落。51吃瓜轻量版省流量，在外面也能随时看。',
    time: '1天前',
    avatar: 'L',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 text-center mb-3">
          瓜友热评
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          吃瓜群众的真实声音
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {comments.map((c, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-2xl p-5 md:p-6 border border-background-200/80"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-sm font-bold text-primary-600 flex-shrink-0">
                  {c.avatar}
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{c.name}</div>
                  <div className="text-xs text-foreground-400">{c.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.text}</p>
              <div className="flex items-center gap-4 mt-4 pt-4 border-t border-background-200/60">
                <span className="flex items-center gap-1 text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line"></i> {Math.floor(Math.random() * 500 + 100)}
                </span>
                <span className="flex items-center gap-1 text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line"></i> 回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}